<template>
  <layout>
    <div slot="content">
      <i-card title="讲解员列表">
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="addGuide.showDialog = true">添加讲解员
          </el-button>
        </div>
        <div slot="content">
          <el-form :inline="true" size="small" style="text-align: right">
            <el-form-item>
              <el-input v-model="filter.mobile" placeholder="手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filter.name" placeholder="讲解员姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getGuideList">查找</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table v-loading="loading" :data="userList" :border="true">
            <el-table-column label="讲解员证件照" prop="status_name">
              <template slot-scope="scope">
                <el-image lazy style="width: 80px; height: 80px;border:1px solid #eee;border-radius: 10px" :preview-src-list="[scope.row.pic]" :src="scope.row.pic" fit="cover"/>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="讲解员姓名"/>
            <el-table-column prop="mobile" label="手机号码"/>
            <el-table-column prop="rank_name" label="等级"/>
            <el-table-column label="讲解员状态" prop="status_name">
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="(scope.row.status & 1)===1">{{ scope.row.status_name }}
                </el-tag>
                <el-tag size="mini" type="danger" v-else>{{ scope.row.status_name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" prop="created_at"/>
            <el-table-column label="操作" width="250" fixed="right">
              <div slot-scope="scope" class="opt-container">
                <el-button size="mini" type="primary" @click="showEditStatus(scope.row)">编辑</el-button>
                <el-button size="mini" type="primary" @click="switchStatus(scope.row)">禁用/启用</el-button>
              </div>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :current-page="pageInfo.current_page" layout="prev, pager, next" :page-size="15"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--添加讲解员-->
      <el-dialog title="提示" :visible.sync="addGuide.showDialog" width="30%">
        <div>
          <el-form :model="addGuide.data" :rules="addGuide.rules" size="small" label-width="95px">
            <el-form-item label="讲解员头像" prop="pic">
              <i-upload v-model="addGuide.data.ori_pic" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="微信二维码" prop="wx_qr_code">
              <i-upload v-model="addGuide.data.ori_wx_qr_code" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="讲解员姓名" prop="name">
              <el-input required v-model="addGuide.data.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
              <el-input required v-model="addGuide.data.mobile"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="short_intro">
              <el-input required v-model="addGuide.data.short_intro"></el-input>
            </el-form-item>
            <el-form-item label="等级" prop="rank">
              <el-select v-model="addGuide.data.rank" placeholder="请选择讲师等级">
                <el-option label="高级讲师" value="1"/>
                <el-option label="资深讲师" value="2"/>
                <el-option label="金牌讲师" value="3"/>
                <el-option label="明星讲师" value="4"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addGuide.showDialog = false">取 消</el-button>
          <el-button type="primary" @click="doAddGuide" :loading="postLoading">确 定</el-button>
        </div>
      </el-dialog>
      <!--编辑讲解员-->
      <el-dialog title="提示" :visible.sync="editGuide.showDialog" width="30%">
        <div>
          <el-form :model="editGuide.data" :rules="editGuide.rules" size="small" label-width="95px">
            <el-form-item label="讲解员头像" prop="pic">
              <i-upload v-model="editGuide.data.ori_pic" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="微信二维码" prop="wx_qr_code">
              <i-upload v-model="editGuide.data.ori_wx_qr_code" :max-files="1"></i-upload>
            </el-form-item>
            <el-form-item label="讲解员姓名" prop="name">
              <el-input required v-model="editGuide.data.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
              <el-input required v-model="editGuide.data.mobile"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="short_intro">
              <el-input required v-model="editGuide.data.short_intro"></el-input>
            </el-form-item>
            <el-form-item label="等级" prop="rank">
              <el-select v-model="editGuide.data.rank" placeholder="请选择讲师等级">
                <el-option label="高级讲师" :value="1"/>
                <el-option label="资深讲师" :value="2"/>
                <el-option label="金牌讲师" :value="3"/>
                <el-option label="明星讲师" :value="4"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editGuide.showDialog = false">取 消</el-button>
          <el-button type="primary" @click="doEditGuide" :loading="postLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "user-list",
  data() {
    return {
      userList: [],
      loading: false,
      postLoading: false,
      pageInfo: {
        current_page: 1,
        total: 0
      },
      teamPageInfo: {
        current_page: 1,
        total: 0
      },
      filter: {
        name: "",
        mobile: "",
      },
      //添加讲师数据
      addGuide: {
        showDialog: false, data: {name: "", mobile: "", short_intro: "", rank: "", ori_pic: [], pic: ""}, rules: {
          name: [
            {required: true, message: '请输入讲师姓名', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入讲师手机号码，需要提前在小程序登录', trigger: 'blur'},
          ],
          short_intro: [
            {required: true, message: '请输入讲师简介', trigger: 'blur'},
          ],
          pic: [
            {required: true, message: '请上传讲师头像', trigger: 'blur'},
          ],
          wx_qr_code: [
            {required: true, message: '请上传微信二维码', trigger: 'blur'},
          ],
          rank: [
            {required: true, message: '请选择讲师等级', trigger: 'blur'},
          ],
        }
      },
      editGuide: {
        showDialog: false, data: {name: "", mobile: "", short_intro: "", rank: "", ori_pic: [], pic: ""}, rules: {
          name: [
            {required: true, message: '请输入讲师姓名', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入讲师手机号码，需要提前在小程序登录', trigger: 'blur'},
          ],
          short_intro: [
            {required: true, message: '请输入讲师简介', trigger: 'blur'},
          ],
          pic: [
            {required: true, message: '请上传讲师头像', trigger: 'blur'},
          ],
          wx_qr_code: [
            {required: true, message: '请上传微信二维码', trigger: 'blur'},
          ],
          rank: [
            {required: true, message: '请选择讲师等级', trigger: 'blur'},
          ],
        }
      },
    }
  },
  methods: {
    getGuideList: function () {
      this.loading = true;
      this.$http.request('guideList', {
        page: this.pageInfo.current_page,
        name: this.filter.name,
        mobile: this.filter.mobile
      }).then(res => {
        this.userList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      })
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getGuideList();
      window.scrollTo(0, 0);
    },
    doAddGuide: function () {
      this.postLoading = true;
      this.addGuide.data.pic = this.addGuide.data.ori_pic[0].path || "";
      this.addGuide.data.wx_qr_code = this.addGuide.data.ori_wx_qr_code[0].path || "";
      this.$http.request('addGuide', this.addGuide.data).then(res => {
        this.getGuideList();
        this.postLoading = false;
        this.addGuide.showDialog = false;
        if(res.status === 'success'){
          this.$message({
            message: res.message, type: 'success',
          });
        }

      })
    },
    //确认禁用
    switchStatus: function (guideInfo) {
      let newStatus = guideInfo.status === 1 ? {status: 2, status_name: "禁用"} : {status: 1, status_name: "启用"};
      let _self = this;
      this.$confirm('确认' + newStatus.status_name + '吗?', '提示', {
        type: 'warning'
      }).then(() => {
       this.$http.request('switchGuideStatus',{user_id:guideInfo.user_id,status:newStatus.status}).then(function (res){
         _self.$message({
           message: res.message, type: 'success',
         });
         _self.getGuideList();
       });

      });
    },
    //编辑讲师
    showEditStatus:function (guideInfo){
      this.editGuide.data = guideInfo;
      this.editGuide.showDialog = true;
    },
    doEditGuide: function () {
      this.postLoading = true;
      this.editGuide.data.pic = this.editGuide.data.ori_pic[0].path || "";
      this.editGuide.data.wx_qr_code = this.editGuide.data.ori_wx_qr_code[0].path || "";
      let _self = this;
      this.$http.request('editGuide', this.editGuide.data).then(res => {
        this.getGuideList();
        this.postLoading = false;
        this.addGuide.showDialog = false;
        if(res.status === 'success'){
          _self.editGuide.showDialog = false;
          _self.$message({
            message: res.message, type: 'success',
          });
        }
      })
    },

    reset: function () {
      window.location.reload();
    }
  },
  created: function () {
    this.getGuideList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/guide-list.vue